import * as ActionTypes from './actionTypes'

// Header Tab Actions

export function intializeHeaderTabWarnings(level, payload, declarationCat,badge) {
return {
  type: ActionTypes.INIT_HEADER_TAB_WARNINGS,
  level,
  payload,
  declarationCat,
  badge
}
}

export function addHeaderTabWarnings(level, value, fieldName) {
  return {
    type: ActionTypes.ADD_HEADER_TAB_WARNINGS,
    value,
    fieldName,
    level,
  }
}

export function deleteHeaderTabWarnings(level, value, fieldName) {
  return {
    type: ActionTypes.DELETE_HEADER_TAB_WARNINGS,
    value,
    fieldName,
    level,
  }
}

// Parties Tab Actions

export function intializePartiesTabWarnings(level, payload,declarationCat) {
  return {
    type: ActionTypes.INIT_PARTIES_TAB_WARNINGS,
    level,
    payload,
    declarationCat
  }
}

export function addPartiesTabWarnings(level, value, fieldName) {
  return {
    type: ActionTypes.ADD_PARTIES_TAB_WARNINGS,
    value,
    fieldName,
    level,
  }
}

export function deletePartiesTabWarnings(level, value, fieldName) {
  return {
    type: ActionTypes.DELETE_PARTIES_TAB_WARNINGS,
    value,
    fieldName,
    level,
  }
}

//value Build Up

export function intializeValueBuildUpTabWarnings(level, payload, declarationCat) {
  return {
    type: ActionTypes.INIT_VALUEBUILDUP_TAB_WARNINGS,
    level,
    payload,
    declarationCat,
  }
  }
  
  export function addValueBuildUpTabWarnings(level, value, fieldName) {
    return {
      type: ActionTypes.ADD_VALUEBUILDUP_TAB_WARNINGS,
      value,
      fieldName,
      level,
    }
  }
  
  export function deleteValueBuildUpTabWarnings(level, value, fieldName) {
    return {
      type: ActionTypes.DELETE_VALUEBUILDUP_TAB_WARNINGS,
      value,
      fieldName,
      level,
    }
  }

  // containers Tab Actions

  export function intializeContainerTabWarnings(level, payload, declarationCat) {
    return {
      type: ActionTypes.INIT_CONTAINER_TAB_WARNINGS,
      level,
      payload,
      declarationCat,
    }
    }
    
    export function addContainerTabWarnings(level, value, fieldName) {
      return {
        type: ActionTypes.ADD_CONTAINER_TAB_WARNINGS,
        value,
        fieldName,
        level,
      }
    }
    
    export function deleteContainerTabWarnings(level, value, fieldName) {
      return {
        type: ActionTypes.DELETE_CONTAINER_TAB_WARNINGS,
        value,
        fieldName,
        level,
      }
    }

    // itemsTab Actions

    export function intializeItemsTabWarnings(level, payload, declarationCat) {
      return {
        type: ActionTypes.INIT_ITEMS_TAB_WARNINGS,
        level,
        payload,
        declarationCat,
      }
      }
  
      export function addItemsTabWarnings(level, value, fieldName) {
        return {
          type: ActionTypes.ADD_ITEMS_TAB_WARNINGS,
          value,
          fieldName,
          level,
        }
      }
  
      export function deleteItemsTabWarnings(level, value, fieldName) {
        return {
          type: ActionTypes.DELETE_ITEMS_TAB_WARNINGS,
          value,
          fieldName,
          level,
        }
      }

